// src/forms/companyProfileConfig.js

const CategoryConfig = [];
export default CategoryConfig;
  